import React from 'react';
import { List } from '@web/molecules';

export { schema } from './list';

//* Separate blok so CMSBlok can render interstitial card styling without extra props at the call site or creating a new component.
//* Icon colors match the lilac Button variant (hero.lilac fill / hero.plum check).
export const component = props => (
  <List isCard {...props} iconColor="hero.lilac" innerIconColor="hero.plum" />
);
